import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import FixedAssetLedgerFilters from "./components/FixedAssetLedgerFilters";
import FixedAssetLedgerTable from "./components/FixedAssetLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const FixedAssetLedger = () => {
  const { message } = App.useApp();
  const { filters } = useSelector((state) => state.fixedAssetLedger);
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Fixed Asset Ledger",
    removeAfterPrint: true,
  });

  const handleNavigateToBack = () => {
    navigate("/reports");
  };

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={handleNavigateToBack}
              style={{ marginRight: 8 }}
            /><Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Fixed Asset Balance Ledger</Title>
            </div>}
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
        />

        <FixedAssetLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <FixedAssetLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Fixed Asset Balance Ledger"
          mode="report-page"
          filters={filters}
          renderTable={() => <FixedAssetLedgerTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default FixedAssetLedger;
